import styled from 'styled-components/macro';

export const TooltipContainer = styled.div.attrs(
  ({ position, targetRect, tooltipRect }) => {
    const margin = 8;
    let leftOffset = 0;
    let topOffset = 0;

    if (targetRect && tooltipRect) {
      switch (position) {
        case 'top':
          leftOffset = (targetRect.width - tooltipRect.width) / 2;
          topOffset = -tooltipRect.height - margin;
          break;
        case 'left':
          leftOffset = -tooltipRect.width - margin;
          topOffset = (targetRect.height - tooltipRect.height) / 2;
          break;
        case 'right':
          leftOffset = targetRect.width + margin;
          topOffset = (targetRect.height - tooltipRect.height) / 2;
          break;
        case 'bottom-left':
          leftOffset = (targetRect.width - tooltipRect.width) + 15;
          topOffset = targetRect.height + 2;
          break;
        default:
          leftOffset = (targetRect.width - tooltipRect.width) / 2;
          topOffset = targetRect.height + margin;
      }
    }

    return { leftOffset, topOffset };
  },
)`
  visibility: hidden;
  opacity: 0;
  position: absolute;
  left: ${({ leftOffset }) => leftOffset}px;
  top: ${({ topOffset }) => topOffset}px;
  background-color: ${({ theme }) => theme.palette.white};
  color: ${({ theme }) => theme.palette.black[100]} !important;
  font-weight: ${({ theme }) => theme.typography.weight.regular} !important;
  font-size: ${({ theme }) => theme.typography.sizes.base};
  padding: ${({ theme }) => theme.spacing(12)};
  box-shadow: 0px 0px 15px #00001414;
  border: 1px solid ${({ theme }) => theme.palette.lightGray[50]};
  border-radius: ${({ theme }) => theme.spacing(10)};
  z-index: 1;
  width: 240px;
  transition: visibility 0.3s, opacity 0.3s;
  transition-delay: 0s;
`;

export const TooltipWrapper = styled.div`
  position: relative;

  &:hover ${TooltipContainer} {
    visibility: visible;
    opacity: 1;
    transition-delay: ${({ delay }) => delay}s;
  }
`;
